export default "__VITE_ASSET__reOegQgo__"